import { Expose } from "class-transformer";
import { Data } from "../data";
import { ExternalAuthenticationData } from "./external-authentication.data";

@Expose()
export class CartaoCreditoData extends Data<CartaoCreditoData> {

  //@Expose({ name: 'titularCartao' })
  nome!: string;
  numero!: string;
  bandeira!: string;
  mesValidade!: string;
  anoValidade!: string;
  cvv!: string;
  valorParcelaCartao!: number;
  numeroParcelasCartao!: number;
  bandeiraCartaoCredito!: string;
  valorTotalParceladoCartao!: number;
  externalAuthentication!: ExternalAuthenticationData;
}
